"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _utils = require('shared/store/utils');
var _helpers = require('shared/actions/helpers');
var _store = require('shared/store');
var _broadcast = require('shared/selectors/broadcast');
var _campaignRecipientsAdds = require('shared/selectors/campaignRecipientsAdds');
var _campaignRecipientsAdd = require('shared/services/campaignRecipientsAdd');


























var _broadcast3 = require('shared/enum/broadcast');


var _broadcastCampaign = require('shared/validation/broadcastCampaign');

const createCampaignActions = _utils.createAsyncActions('CreateCampaign')
const updateCampaignActions = _utils.createAsyncActions('UpdateCampaign')
const getCampaignActions = _utils.createAsyncActions('GetCampaign')
const findCampaignsActions = _utils.createAsyncActions('FindCampaigns')
const archiveCampaignActions = _utils.createAsyncActions('ArchiveCampaign')
const unarchiveCampaignActions = _utils.createAsyncActions('UnarchiveCampaign')
const findCampaignMessagesActions = _utils.createAsyncActions('FindCampaignMessages')
// The start-time lookup; no reducer handles it, so the loaded table is left alone.
const findCampaignStartTimeActions = _utils.createAsyncActions('FindCampaignStartTime')
// A page of loadCampaignMessages. Unlike findCampaignMessagesActions it merges
// into the loaded messages instead of replacing them.
const loadCampaignMessagesPageActions = _utils.createAsyncActions('LoadCampaignMessagesPage')
const addPatientsToCampaignActions = _utils.createAsyncActions('AddPatientsToCampaign')
const dequeuePatientsInCampaignActions = _utils.createAsyncActions('DequeuePatientsInCampaign')
const removePatientsFromCampaignActions = _utils.createAsyncActions('RemovePatientsFromCampaign')
const startCampaignActions = _utils.createAsyncActions('StartCampaign')
const checkCampaignGateActions = _utils.createAsyncActions('CheckCampaignGate')
const previewCampaignRecipientsActions = _utils.createAsyncActions('PreviewCampaignRecipients')
const addCampaignRecipientsActions = _utils.createAsyncActions('AddCampaignRecipients')
const getCampaignRecipientsAddsActions = _utils.createAsyncActions('GetCampaignRecipientsAdds')
const addCampaignVariableActions = _utils.createAsyncActions('AddCampaignVariable')
const updateCampaignVariableActions = _utils.createAsyncActions('UpdateCampaignVariable')
const removeCampaignVariableActions = _utils.createAsyncActions('RemoveCampaignVariable')
const updateCampaignRecipientValuesActions = _utils.createAsyncActions('UpdateCampaignRecipientValues')
const downloadRecipientErrorsActions = _utils.createAsyncActions('DownloadRecipientErrors')
const pauseCampaignActions = _utils.createAsyncActions('PauseCampaign')
const stopCampaignActions = _utils.createAsyncActions('StopCampaign')

 const actionCreators = {
  createCampaignActions,
  updateCampaignActions,
  getCampaignActions,
  findCampaignsActions,
  archiveCampaignActions,
  unarchiveCampaignActions,
  findCampaignMessagesActions,
  loadCampaignMessagesPageActions,
  addPatientsToCampaignActions,
  dequeuePatientsInCampaignActions,
  removePatientsFromCampaignActions,
  startCampaignActions,
  checkCampaignGateActions,
  previewCampaignRecipientsActions,
  addCampaignRecipientsActions,
  getCampaignRecipientsAddsActions,
  addCampaignVariableActions,
  updateCampaignVariableActions,
  removeCampaignVariableActions,
  updateCampaignRecipientValuesActions,
  downloadRecipientErrorsActions,
  pauseCampaignActions,
  stopCampaignActions,
}; exports.actionCreators = actionCreators

const createCampaign = ({
  Name, TeamKey, SenderKey,
  MessageType, MessageTemplate,
  MessageDelay = _broadcastCampaign.DEFAULT_MESSAGE_DELAY_MS,
}) => _helpers.wsCommand(
  'CreateCampaign',
  createCampaignActions,
  { Name, TeamKey, SenderKey, MessageType, MessageTemplate, MessageDelay },
  null,
)

const updateCampaign = ({
  CampaignKey, Name,
  TeamKey, SenderKey,
  MessageType, MessageTemplate,
  MessageDelay = _broadcastCampaign.DEFAULT_MESSAGE_DELAY_MS,
}) => _helpers.wsCommand(
  'UpdateCampaign',
  updateCampaignActions,
  { CampaignKey, Name, TeamKey, SenderKey, MessageType, MessageTemplate, MessageDelay },
  { isOptimistic: true },
)

/* The server runs each command concurrently, so a campaign read can answer
 * with the Archived flag from before an archive or unarchive (Rev 20 review
 * R800-2). A read keeps the store's flag, which only the change's own reply
 * sets, when the change was in flight as the read was sent, started while it
 * was out, or is still in flight. */
let archiveChangeCount = 0
const archiveChangedAt = new Map()
const archiveChangesInFlight = new Map()

const changeArchived = (CampaignKey, change) => {
  archiveChangedAt.set(CampaignKey, ++archiveChangeCount)
  archiveChangesInFlight.set(CampaignKey, (_nullishCoalesce(archiveChangesInFlight.get(CampaignKey), () => ( 0))) + 1)
  return change().finally(() => {
    archiveChangesInFlight.set(CampaignKey, (_nullishCoalesce(archiveChangesInFlight.get(CampaignKey), () => ( 1))) - 1)
  })
}

/* Call as the read is sent; the result fixes up its campaigns on arrival. */
const startCampaignRead = () => {
  const sentAt = archiveChangeCount
  const inFlightAtSend = new Set(
    [...archiveChangesInFlight].filter(([, n]) => n > 0).map(([key]) => key),
  )
  return (c) => {
    const key = c.CampaignKey
    const isStale = inFlightAtSend.has(key)
      || (_nullishCoalesce(archiveChangedAt.get(key), () => ( 0))) > sentAt
      || (_nullishCoalesce(archiveChangesInFlight.get(key), () => ( 0))) > 0
    const stored = isStale ? _broadcast.selectCampaignByKey.call(void 0, _store.getState.call(void 0, ), key) : null
    return stored ? { ...c, Archived: stored.Archived } : c
  }
}

const getCampaign = (CampaignKey) => {
  const fresh = startCampaignRead()
  return _helpers.wsCommand(
    'GetCampaign',
    { ...getCampaignActions, SUCCESS: (c, meta) => getCampaignActions.SUCCESS(fresh(c), meta) },
    { CampaignKey },
    null,
  )
}

const findCampaigns = (request) => {
  const fresh = startCampaignRead()
  return _helpers.wsCommand(
    'FindCampaigns',
    {
      ...findCampaignsActions,
      SUCCESS: (r, meta) => findCampaignsActions.SUCCESS({ ...r, Campaigns: r.Campaigns.map(fresh) }, meta),
    },
    request,
    null,
  )
}

/* Archive and unarchive change the campaign only once the server agrees
 * (Rev 20 review R800-1/R800-2): the campaign on screen keeps its unsaved
 * work if the change is refused, and there's no optimistic state for a read
 * answering meanwhile to be replayed over. */
const archiveCampaign = (CampaignKey) => changeArchived(CampaignKey, () =>
  _helpers.wsCommand(
    'ArchiveCampaign',
    archiveCampaignActions,
    { CampaignKey },
    null,
  ))
const unarchiveCampaign = (CampaignKey) => changeArchived(CampaignKey, () =>
  _helpers.wsCommand(
    'UnarchiveCampaign',
    unarchiveCampaignActions,
    { CampaignKey },
    null,
  ))

const findCampaignMessages = (
  CampaignKey,
  Offset,
  Limit,
  Status = null,
) =>
  _helpers.wsCommand(
    'FindCampaignMessages',
    findCampaignMessagesActions,
    { CampaignKey, Offset, Limit, Status },
    null,
  )

/* Rev 27 P2: when a scheduled campaign starts. The campaign has no start
 * time; one Send stamps all its messages with the same ScheduledAt, so the
 * first queued message's is the start (null when sent for now). */
const findCampaignStartTime = (CampaignKey) =>
  _helpers.wsCommand(
    'FindCampaignMessages',
    findCampaignStartTimeActions,
    { CampaignKey, Offset: 0, Limit: 1, Status: _broadcast3.broadcastMsgStatus.QUEUED },
    {},
  ).then(r => _nullishCoalesce(_optionalChain([r, 'access', _ => _.Messages, 'access', _2 => _2[0], 'optionalAccess', _3 => _3.ScheduledAt]), () => ( null)))

const CAMPAIGN_MESSAGES_PAGE_SIZE = 100








/* Loads a campaign's messages page by page, up to maxMessages, merging each
 * page into the store. */
const loadCampaignMessages = async (
  CampaignKey,
  maxMessages,
  Status = null,
) => {
  const result = { Messages: [], Patients: {}, isComplete: true }
  for (;;) {
    const Limit = Math.min(CAMPAIGN_MESSAGES_PAGE_SIZE, maxMessages - result.Messages.length)
    if (Limit <= 0) {
      result.isComplete = false
      return result
    }
    const page = await _helpers.wsCommand(
      'FindCampaignMessages',
      loadCampaignMessagesPageActions,
      { CampaignKey, Offset: result.Messages.length, Limit, Status },
      null,
    )
    result.Messages.push(...page.Messages)
    Object.assign(result.Patients, page.Patients)
    if (page.Messages.length < Limit) return result
  }
}

const addPatientsToCampaign = (CampaignKey, PatientKeys = []) =>
  _helpers.wsCommand(
    'AddPatientsToCampaign',
    addPatientsToCampaignActions,
    { CampaignKey, PatientKeys },
    { isOptimistic: true },
  )

const dequeuePatientsInCampaign = (CampaignKey, PatientKeys = []) =>
  _helpers.wsCommand(
    'DequeuePatientsInCampaign',
    dequeuePatientsInCampaignActions,
    { CampaignKey, PatientKeys },
    { isOptimistic: true },
  )

const removePatientsFromCampaign = (CampaignKey, PatientKeys = []) =>
  _helpers.wsCommand(
    'RemovePatientsFromCampaign',
    removePatientsFromCampaignActions,
    { CampaignKey, PatientKeys },
    { isOptimistic: true },
  )

const startCampaign = (CampaignKey, NumPatients, ScheduleAt) =>
  _helpers.wsCommand(
    'StartCampaign',
    startCampaignActions,
    { CampaignKey, NumPatients, ScheduleAt },
    { isOptimistic: true },
  )

/* Runs the launch gate without changing anything; pass MessageTemplate or
 * MessageType to check an unsaved edit. */
const checkCampaignGate = (request) =>
  _helpers.wsCommand(
    'CheckCampaignGate',
    checkCampaignGateActions,
    request,
    {},
  )

/* The first preview of a 50,000-row file reads the whole directory; it's
 * meant to answer in seconds, and this leaves room on a slow day. Later
 * pages reuse it and answer at once. */
const PREVIEW_CAMPAIGN_RECIPIENTS_TIMEOUT_MS = 60 * 1000

/* Reports what adding the sources (CSV files, picks and new patients) would
 * do, without writing; with FileView, also one page of one file. */
const previewCampaignRecipients = (request) =>
  _helpers.wsCommand(
    'PreviewCampaignRecipients',
    previewCampaignRecipientsActions,
    request,
    {},
    undefined,
    PREVIEW_CAMPAIGN_RECIPIENTS_TIMEOUT_MS,
  )

/* A synchronous Add (Add existing, or a file without Background) can
 * outlast the default command timeout. A timed-out wait says nothing about
 * the Add: the reply is dropped, and whether the server finished it isn't
 * known here (a re-run adds nothing twice). A background Add answers at once. */
const ADD_CAMPAIGN_RECIPIENTS_TIMEOUT_MS = 5 * 60 * 1000

/* Adds the sources' recipients; refused by the gate on a started campaign
 * when a new recipient would get a broken message. With Background and a
 * file source the reply is { Add } as soon as the Add starts; otherwise it
 * is the finished result. */
const addCampaignRecipients = (request) =>
  _helpers.wsCommand(
    'AddCampaignRecipients',
    addCampaignRecipientsActions,
    request,
    {},
    undefined,
    ADD_CAMPAIGN_RECIPIENTS_TIMEOUT_MS,
  )

/* GetCampaignRecipientsAdds takes at most this many campaigns at once. */
const RECIPIENTS_ADDS_KEYS_LIMIT = 100

/* P2': the latest background Add of each campaign (with its failed rows),
 * into the store; asked in batches the server accepts. After a reconnect
 * that missed the pushes (review F-3), an Add this tab knew of may have moved
 * on or ended: a loaded campaign whose Add did is read again, as the push
 * would have done (shared/listeners/websocket.ts). An Add first seen here
 * changes nothing, so opening a page doesn't re-read its campaigns. */
const getCampaignRecipientsAdds = async (CampaignKeys) => {
  const keys = [...new Set(CampaignKeys)]
  const known = keys.map(key => _campaignRecipientsAdds.selectCampaignRecipientsAdd.call(void 0, _store.getState.call(void 0, ), key))
  const batches = []
  for (let i = 0; i < keys.length; i += RECIPIENTS_ADDS_KEYS_LIMIT) {
    batches.push(keys.slice(i, i + RECIPIENTS_ADDS_KEYS_LIMIT))
  }
  const replies = await Promise.all(batches.map(batch => _helpers.wsCommand(
    'GetCampaignRecipientsAdds',
    getCampaignRecipientsAddsActions,
    { CampaignKeys: batch },
    {},
  )))
  const state = _store.getState.call(void 0, )
  keys.forEach((key, i) => {
    const before = known[i]
    if (before && _campaignRecipientsAdd.isNewAddState.call(void 0, before, _campaignRecipientsAdds.selectCampaignRecipientsAdd.call(void 0, state, key)) && _broadcast.selectCampaignByKey.call(void 0, state, key)) {
      getCampaign(key).catch(() => undefined)
    }
  })
  return replies.flatMap(r => r.Adds)
}

/* A rename or removal rewrites every saved recipient's values (up to 50,000),
 * which can outlast the default command timeout. */
const CAMPAIGN_VARIABLE_TIMEOUT_MS = 2 * 60 * 1000

/* Rev 31 B2: change one variable. After sending starts a variable can still
 * be added and its default changed; a rename is refused, and so is removing
 * one the message uses (Rev 32 V4). Each stores the returned campaign. */
const addCampaignVariable = (request) =>
  _helpers.wsCommand(
    'AddCampaignVariable',
    addCampaignVariableActions,
    request,
    {},
    undefined,
    CAMPAIGN_VARIABLE_TIMEOUT_MS,
  )

const updateCampaignVariable = (request) =>
  _helpers.wsCommand(
    'UpdateCampaignVariable',
    updateCampaignVariableActions,
    request,
    {},
    undefined,
    CAMPAIGN_VARIABLE_TIMEOUT_MS,
  )

const removeCampaignVariable = (request) =>
  _helpers.wsCommand(
    'RemoveCampaignVariable',
    removeCampaignVariableActions,
    request,
    {},
    undefined,
    CAMPAIGN_VARIABLE_TIMEOUT_MS,
  )

/* Rev 32 V3: edits one unsent recipient's values; a blank clears theirs.
 * Stores the returned campaign. */
const updateCampaignRecipientValues = (request) =>
  _helpers.wsCommand(
    'UpdateCampaignRecipientValues',
    updateCampaignRecipientValuesActions,
    request,
    {},
  )

/* A CSV of the file's rows that can't be added, with the reason. */
const downloadRecipientErrors = (request) =>
  _helpers.wsCommand(
    'DownloadRecipientErrors',
    downloadRecipientErrorsActions,
    request,
    {},
  )

const pauseCampaign = (CampaignKey) =>
  _helpers.wsCommand(
    'PauseCampaign',
    pauseCampaignActions,
    { CampaignKey },
    { isOptimistic: true },
  )

const stopCampaign = (CampaignKey) =>
  _helpers.wsCommand(
    'StopCampaign',
    stopCampaignActions,
    { CampaignKey },
    { isOptimistic: true },
  )

exports. default = {
  createCampaign,
  updateCampaign,
  getCampaign,
  findCampaigns,
  archiveCampaign,
  unarchiveCampaign,
  findCampaignMessages,
  findCampaignStartTime,
  addPatientsToCampaign,
  removePatientsFromCampaign,
  dequeuePatientsInCampaign,
  loadCampaignMessages,
  startCampaign,
  checkCampaignGate,
  previewCampaignRecipients,
  addCampaignRecipients,
  getCampaignRecipientsAdds,
  addCampaignVariable,
  updateCampaignVariable,
  removeCampaignVariable,
  updateCampaignRecipientValues,
  downloadRecipientErrors,
  pauseCampaign,
  stopCampaign,
}
